import flip from "@popperjs/core/lib/modifiers/flip.js";
import preventOverflow from "@popperjs/core/lib/modifiers/preventOverflow.js";
import { createPopper } from "@popperjs/core/lib/popper-lite.js";
import { ref } from "vue";
const vVoixPopper = {
  mounted(el, binding) {
    binding.popper = document.createElement("div");
    binding.popper.className = "z-[5000000000] font-voix-studio text-sm bg-gray-800 text-gray-300 border border-gray-600 rounded shadow p-2 opacity-0 pointer-events-none transition-all duration-200 ease-out";
    binding.popper.innerHTML = binding.value;
    document.getElementsByTagName("body")[0].appendChild(binding.popper);
    function buildPlacement(modifiers) {
      const possiblePlacements = [
        "auto",
        "auto-start",
        "auto-end",
        "top",
        "top-start",
        "top-end",
        "bottom",
        "bottom-start",
        "bottom-end",
        "right",
        "right-start",
        "right-end",
        "left",
        "left-start",
        "left-end"
      ];
      for (const placement of possiblePlacements) {
        if (modifiers[placement])
          return placement;
      }
      return "auto";
    }
    binding.popperInstance = createPopper(el, binding.popper, {
      modifiers: [{
        name: "offset",
        options: {
          offset: [10, 20]
        }
      }, preventOverflow, flip],
      placement: buildPlacement(binding.modifiers)
    });
    const timer = ref(null);
    el.addEventListener("mouseenter", () => {
      timer.value = setTimeout(() => {
        binding.popper.classList.remove("opacity-0");
        binding.popper.classList.add("opacity-100");
        binding.popperInstance.update();
      }, 500);
    });
    el.addEventListener("mouseleave", () => {
      clearTimeout(timer.value);
      binding.popper.classList.remove("opacity-100");
      binding.popper.classList.add("opacity-0");
    });
    el.addEventListener("click", () => {
      clearTimeout(timer.value);
      binding.popper.classList.remove("opacity-100");
      binding.popper.classList.add("opacity-0");
    });
  },
  updated(el, binding) {
    if (binding.popper)
      binding.popper.innerHTML = binding.value;
  },
  unmounted(el, binding) {
    if (binding.popperInstance)
      binding.popperInstance.destroy();
    if (binding.popper)
      binding.popper.remove();
  }
};
export default vVoixPopper;
